<!-- 出勤类型 -->
<template>
  <el-form-item :label="label">
    <el-select
      v-model="typeList"
      :multiple="config.multiple"
      :placeholder="placeholder"
      @clear="reset"
      :clearable="clearable"
      collapse-tags
      collapse-tags-tooltip
    >
      <el-option v-for="item in chargeTypes" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-出勤状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '出勤状态：',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    include0: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');

    const chargeTypes = ref([
      {
        id: 1,
        name: '出勤',
      },
      {
        id: 2,
        name: '迟到',
      },
      {
        id: 3,
        name: '请假',
      },
      {
        id: 4,
        name: '未到',
      },
    ]);
    if (props.include0) {
      chargeTypes.value.push({
        id: 0,
        name: '未点名',
      });
    }
    let typeList;
    function reset() {
      typeList.value = props.value;
    }

    typeList = useQuery('courseStudentStatusList', props.value, reset);

    return {
      reset,
      chargeTypes,
      typeList,
    };
  },
};
</script>
